import * as React from 'react';
import EfImg from '@elem/ui/ef-img';
import styled from './index.module.scss';
import { getIsLogin } from '@/utils/cookie';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import { getCurrentPlan } from '@/service/referral';
import gtm from '@/utils/gtm';

const { useState, useEffect } = React;

const Referral = () => {
    const { t } = useLang('membersday.referral');
    const { useRouter } = useGlobal();
    const router = useRouter();
    const { locale } = getLocal();

    const [isLogin, setIsLogin] = useState(false);
    const [isHasRefer, setIsHasRefer] = useState(false);

    const handleGtm = (buttonName: string) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_button',
                position: 'banner_1',
                button_name: buttonName,
            });
        } catch (error) {
            console.log(error);
        }
    };

    const handleLogin = React.useCallback(() => {
        handleGtm(t('refer_now'));
        router.push(`${locale}/referral`);
    }, [router, locale, t]);

    const isReferBtnDisabled = React.useMemo(() => isLogin && !isHasRefer, [isLogin, isHasRefer]);

    useEffect(() => {
        setIsLogin(getIsLogin());
        // 获取当前用户是否有推荐计划 改成普通 referral开启就开启
        getCurrentPlan(locale, `/${locale}/referral`).then((res: any) => {
            if (res.code !== '0' || !res.data) return;
            setIsHasRefer(true);
        });
    }, [locale]);

    return (
        <div className={styled.Referral} id="referral">
            <div id={'referral-modal'} style={{ opacity: '0' }}></div>
            <div id={'referral-share'} style={{ opacity: '0' }}></div>
            <div className="fy2025-referral-container">
                <div className="item-img">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1742798395605/bg_pc.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1742816794794/bg_pad.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1742798401342/bg_h5.jpg"
                    />
                </div>
                <div className="text-content">
                    <div className="desc">{t('card_desc')}</div>
                    <div className="bottom-action">
                        <div className={`text-button ${isReferBtnDisabled ? 'text-button-disabled' : ''}`} onClick={handleLogin}>
                            {t('refer_now')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Referral;
